import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import APIHelper from '../HelperMethodsForAPI'
import { RunVisualUnitWithId_VisualUnit } from '../../Interfaces/APIContracts/RunVisualUnitWithId_VisualUnit'
import { RunVisualUnitWithId_VisualUnit_Extended } from '../../Interfaces/VisualUnit/RunVisualUnitWithId_VisualUnit'

export interface IVUConfigPayload {
    vuId: number
    Expanded: boolean
}
export interface IVUconfigData {
    vuConfiguration: IVUConfigPayload[]
}

export interface IVUconfigResponse {
    statusCode: number | string
    data: RunVisualUnitWithId_VisualUnit_Extended
}
export interface IDrillthrusetColumn {
    Id: number
    displayOrder: number
}
export interface IMetadataDrillThruSet{
        Id: number | string
        drillThruSetColumns: IDrillthrusetColumn[]
}

export const VUConfigAPI = createApi({
    reducerPath: 'vu_configuration', //our reducer lives at store.reducer
    tagTypes: ['vuconfigformdata'],
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3' ), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        submitForm: build.mutation<IVUconfigResponse, Partial<IVUConfigPayload>>({
            query: (body) => ({
                url: '/Account/me/VUConfiguration',
                method: 'PATCH',
                body,
            }),
        }),
    }),
})
export const setDrillThruColumnView = createApi({
    reducerPath: 'set_view', //our reducer lives at store.reducer
    // tagTypes: ['vuconfigformdata'],
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3' ), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        setView: build.mutation<IVUconfigResponse, Partial<IMetadataDrillThruSet>>({
            query: (body) => ({
                url: '/MetadataDrillThru',
                method: 'PATCH',
                body: APIHelper.prepareFormData(body),
            }),
        }),
    }),
})

export interface IexecuteTableData {
    id: number
    tempId: number
    isAsync: boolean
    viewerType: number
    callerType: string
    pageSize: number
    pageNumber: number
    grandTotal: boolean
    sortColumn: any
    sortOrder: any
    forceRefresh: number
    privacyLock: number
}

export interface IexecuteChartData {
    id: number
    tempId: number
    isAsync: boolean
    viewerType: number
    callerType: string
    chartFilter: { [s: string]: any }
    chartSwitch: { [s: string]: any }
    chartSettings: { [s: string]: any }
}

export interface IexecuteTableResponse {
    statusCode: number | string
    data: any
}

export const executeAPI = createApi({
    reducerPath: 'execute', //our reducer lives at store.reducer
    tagTypes: ['execute_api'],
    baseQuery: getBaseQuery(getBaseUrl() + 'API/v3'), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        executeTable: build.mutation<IexecuteTableResponse, Partial<IexecuteTableData>>({
            query: (body) => ({
                url: '/visualunit/executeTable',
                method: 'POST',
                body: APIHelper.prepareFormData(body),
            }),
        }),
        executeChart: build.mutation<IexecuteTableResponse, Partial<IexecuteChartData>>({
            query: (body) => ({
                url: '/visualunit/executeChart',
                method: 'POST',
                body: APIHelper.prepareFormData(body),
            }),
        }),
        executeVU: build.mutation({
            query: (body) => ({
                url: '/visualunit/execute',
                method: 'POST',
                body: APIHelper.prepareFormData(body),
            }),
        }),
        executePreview: build.mutation({
            query: (body) => ({
                url: '/visualunit/Preview',
                method: 'POST',
                body: body,
            }),
        }),
        markVUFavourite: build.mutation({
            query: ({ body, method }) => ({
                url: '/visualunit/favourite',
                method: method,
                body: APIHelper.prepareFormData(body),
            }),
        }),
        saveAsNewVU: build.mutation({
            query: (reqVisualUnitData) => ({
                url: '/visualunit/SaveAsNewVU',
                method: 'POST',
                body: reqVisualUnitData,
            }),
        }),
    }),
})

export const getVuParamsAPI = createApi({
    reducerPath: 'getParams',
    tagTypes: ['VUParams'],
    baseQuery: getBaseQuery(getBaseUrl() + 'API/v3'), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        getVUParams: build.mutation({
            query: (body) => ({
                url: `/visualunit/GetVisualUnitParameters?dashBoardId=${body.dashBoardId}&visualUnitId=${body.visualUnitId}`,
                method: 'GET',
                //   body: APIHelper.prepareFormData(body),
            }),
        }),
        getFilters: build.mutation({
            query: (body) => ({
                url: '/Metadatas/filters',
                method: 'POST',
                body: APIHelper.prepareFormData(body),
            }),
        }),
        getMeasures: build.mutation({
            query: () => ({
                url: '/Metadatas/measures',
                method: 'POST',
                //   body: APIHelper.prepareFormData(body),
            }),
        }),
    }),
})

export const { useSubmitFormMutation } = VUConfigAPI
export const { useSetViewMutation } = setDrillThruColumnView
export const {
    useExecuteTableMutation,
    useExecuteChartMutation,
    useExecuteVUMutation,
    useMarkVUFavouriteMutation,
    useExecutePreviewMutation,
    useSaveAsNewVUMutation,
} = executeAPI
export const { useGetVUParamsMutation, useGetFiltersMutation, useGetMeasuresMutation } =
    getVuParamsAPI

// export const { useSubmitExecuteTableFormMutation } = executeTableAPI
